<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <transition-group name="fadeInUp" mode="in-out">
      <!-- Start Main Loader -->
      <MainLoader key="loader" v-if="loading" />
      <!-- End Main Loader -->

      <div key="main" v-else>
        <!-- Start Statistics Card-->
        <div class="order-details-page mb-5">
          <div class="order-status">
            <h2 class="title">
              {{ $t("titles.orderNumber") }} {{ `# ${allData.order_num}` }}
            </h2>
            <div class="status">
              <div class="date">
                <h5 v-if="allData.status_trans">
                  <span
                    v-if="allData.status == 'order_placed'"
                    class="status success bg-transparent"
                  >
                    {{ allData.status_trans }}
                  </span>
                  <span
                    v-else-if="
                      allData.status == 'delivered' ||
                      allData.status == 'arrived'
                    "
                    class="status success bg-transparent"
                  >
                    {{ allData.status_trans }}
                  </span>
                  <span
                    v-else-if="
                      allData.status == 'admin_reject' ||
                      allData.status == 'driver_cancel' ||
                      allData.status == 'client_cancel' ||
                      allData.status == 'admin_cancel' ||
                      allData.status == 'admin_cancel_after_delivered'
                    "
                    class="status canceled bg-transparent"
                  >
                    {{ allData.status_trans }}
                  </span>
                  <span v-else class="status pending bg-transparent">
                    {{ allData.status_trans }}
                  </span>
                </h5>
                <h5>
                  <span
                    class="status canceled bg-transparent"
                    v-if="allData.reject_reason"
                  >
                    {{ allData.reject_reason.title }}
                  </span>
                </h5>
              </div>
              <div class="action">
                <!-- <div class="action" v-if="!allData.have_item_out_of_stock"> -->
                <div
                  v-if="
                    allData.status == 'order_placed' ||
                    allData.status == 'progress' ||
                    allData.status == 'arrived' ||
                    allData.status == 'on_the_way'
                  "
                >
                  <!-- <span class="status success">
                    {{ item.status_trans }}
                  </span> -->

                  <div class="input_wrapper">
                    <v-select
                      :label="allData.status_trans"
                      solo
                      v-model="selectedStatus"
                      :items="orderStatusList(allData.status)"
                      @input="changeStatus($event)"
                    ></v-select>
                  </div>
                </div>
                <!-- <span
                  v-else-if="
                    allData.status == 'arrived' ||
                    allData.status == 'delivered' ||
                    allData.status == 'on_the_way'
                  "
                  class="status success bg-transparent"
                >
                  {{ allData.status_trans }}
                </span> -->
                <span
                  v-else-if="
                    allData.status == 'admin_reject' ||
                    allData.status == 'client_cancel' ||
                    allData.status == 'driver_cancel' ||
                    allData.status == 'admin_cancel' ||
                    allData.status == 'delivered' ||
                    allData.status == 'admin_cancel_after_delivered'
                  "
                  class="status canceled bg-transparent"
                >
                  <!-- {{ allData.status_trans }} -->
                </span>

                <div class="d-flex gap-3 justify-content-center" v-else>
                  <v-btn
                    class="px-10"
                    color="#1B5E20"
                    style="color: white"
                    @click="checkShippingWay()"
                    v-if="allData.branch?.have_shipping_integration && !allData.is_pickup_from_branch"
                  >
                  {{ $t("accept") }}
                </v-btn>
                  <v-btn
                    class="px-10"
                    color="#1B5E20"
                    style="color: white"
                    @click="changeStatus($event, 'order_placed')"
                    v-else
                  >
                  {{ $t("accept") }}
                </v-btn>
                  <!-- <v-btn
                    class="px-10"
                    color="#1B5E20"
                    style="color: white"
                    @click="changeStatus($event, 'order_placed')"
                  > -->
                  <v-btn
                    class="px-10"
                    color="#F44336 "
                    style="color: white"
                    @click="reject_reason_model = true"
                  >
                    {{ $t("reject") }}
                  </v-btn>
                </div>
              </div>
            </div>
            <div class="shipping-panel" v-if="showShippingPanel">
              <div class="shipping-panel__main">
                <span
                  v-if="allData.shipping_status"
                  class="shipping-chip"
                  :class="shippingTone"
                >
                  <v-icon small>mdi-truck-delivery</v-icon>
                  {{ $t("companyStatus." + allData.shipping_status) }}
                </span>
                <span v-if="shippingProviderLabel" class="shipping-provider">
                  {{ shippingProviderLabel }}
                </span>
              </div>
              <div
                class="shipping-panel__meta"
                v-if="shippingDriver || allData.tracking_url"
              >
                <div v-if="shippingDriver" class="shipping-driver">
                  <v-icon small>mdi-account</v-icon>
                  <div>
                    <strong>{{ shippingDriver.name || $t("titles.courierDriver") }}</strong>
                    <a
                      v-if="shippingDriver.phone"
                      :href="'tel:' + shippingDriver.phone"
                    >{{ shippingDriver.phone }}</a>
                  </div>
                </div>
                <a
                  v-if="driverMapUrl"
                  class="shipping-link"
                  :href="driverMapUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <v-icon x-small>mdi-map-marker</v-icon>
                  {{ $t("titles.driverLocation") }}
                </a>
                <a
                  v-if="allData.tracking_url"
                  class="shipping-link"
                  :href="allData.tracking_url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <v-icon x-small>mdi-open-in-new</v-icon>
                  {{ $t("titles.trackingUrl") }}
                </a>
              </div>
              <v-btn
                v-if="canChangeShipping"
                class="shipping-change"
                outlined
                small
                color="#1B5E20"
                @click="checkShippingWay('reassign')"
              >
                {{ $t("changeShippingCompany") }}
              </v-btn>
            </div>
          </div>
          <hr class="line" />
          <div class="details border-right-0">
            <div class="row">
                  <div class="col-lg-4">
                    <div class="customer user-card" v-if="allData.client">
                      <div class="user-card__top">
                        <img
                          v-if="allData.client.avatar"
                          class="user-card__avatar"
                          :src="allData.client.avatar"
                          :alt="allData.client.full_name"
                        />
                        <span v-else class="user-card__avatar">{{ clientInitials }}</span>
                        <div class="user-card__id">
                          <span class="user-card__label">{{ $t("titles.userInfo") }}</span>
                          <strong>{{ allData.client.full_name }}</strong>
                          <span
                            v-if="typeof allData.client.is_active === 'boolean'"
                            class="user-card__state"
                            :class="allData.client.is_active ? 'is-on' : 'is-off'"
                          >
                            {{ allData.client.is_active ? $t("labels.activate") : $t("inactive") }}
                          </span>
                        </div>
                      </div>
                      <a
                        v-if="allData.client.phone_complete_form"
                        class="user-card__row"
                        :href="'tel:' + allData.client.phone_complete_form"
                      >
                        <v-icon small>mdi-phone</v-icon>
                        <span>
                          <small>{{ $t("titles.phone") }}</small>
                          {{ allData.client.phone_complete_form }}
                        </span>
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-4" v-if="allData.address">
                    <div class="customer address-card">
                      <div class="address-card__top">
                        <span class="address-card__pin">
                          <v-icon>mdi-map-marker</v-icon>
                        </span>
                        <div class="address-card__id">
                          <span class="address-card__label">{{ $t("titles.shippingAddress") }}</span>
                          <strong>{{ allData.address.place_description || allData.address.location_description }}</strong>
                          <span v-if="allData.address.country" class="address-card__country">
                            {{ allData.address.country.name }}
                          </span>
                        </div>
                      </div>
                      <p
                        v-if="allData.address.location_description && allData.address.place_description"
                        class="address-card__desc"
                      >
                        {{ allData.address.location_description }}
                      </p>
                      <div
                        class="address-card__chips"
                        v-if="allData.address.building || allData.address.floor || allData.address.apartment"
                      >
                        <span v-if="allData.address.building">
                          {{ $t("titles.building") }} {{ allData.address.building }}
                        </span>
                        <span v-if="allData.address.floor">
                          {{ $t("titles.floor") }} {{ allData.address.floor }}
                        </span>
                        <span v-if="allData.address.apartment">
                          {{ $t("titles.flatNum") }} {{ allData.address.apartment }}
                        </span>
                      </div>
                      <a
                        v-if="allData.address.phone"
                        class="user-card__row"
                        :href="'tel:' + (allData.address.phone_code || '') + allData.address.phone"
                      >
                        <v-icon small>mdi-phone</v-icon>
                        <span>
                          <small>{{ $t("titles.phone") }}</small>
                          {{ (allData.address.phone_code || "") + allData.address.phone }}
                        </span>
                      </a>
                      <a
                        v-if="addressMapUrl"
                        class="address-card__map"
                        :href="addressMapUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <v-icon small>mdi-map</v-icon>
                        {{ $t("clientLocation") }}
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-4" v-if="allData.branch">
                    <div class="customer address-card">
                      <div class="address-card__top">
                        <span class="address-card__pin">
                          <v-icon>mdi-store</v-icon>
                        </span>
                        <div class="address-card__id">
                          <span class="address-card__label">{{ $t("titles.branch_info") }}</span>
                          <strong>{{ allData.branch.full_name }}</strong>
                          <span v-if="allData.branch.code" class="address-card__country">
                            {{ $t("forms.labels.branch_code") }} {{ allData.branch.code }}
                          </span>
                        </div>
                      </div>
                      <p
                        v-if="allData.branch.location_description && allData.branch.location_description !== 'undefined'"
                        class="address-card__desc"
                      >
                        {{ allData.branch.location_description }}
                      </p>
                      <a
                        v-if="allData.branch.phone_complete_form"
                        class="user-card__row"
                        :href="'tel:' + allData.branch.phone_complete_form"
                      >
                        <v-icon small>mdi-phone</v-icon>
                        <span>
                          <small>{{ $t("titles.phone") }}</small>
                          {{ allData.branch.phone_complete_form }}
                        </span>
                      </a>
                      <a
                        v-if="allData.branch.lat != null && allData.branch.lng != null"
                        class="address-card__map"
                        :href="'https://www.google.com/maps?q=' + allData.branch.lat + ',' + allData.branch.lng"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <v-icon small>mdi-map-marker</v-icon>
                        {{ $t("titles.coordinates") }}
                        {{ allData.branch.lat + " , " + allData.branch.lng }}
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="order-info order-facts">
                      <div class="order-facts__head">
                        <span class="order-facts__icon">
                          <v-icon>mdi-clipboard-text-outline</v-icon>
                        </span>
                        <span class="order-facts__title">{{ $t("titles.orderDetails") }}</span>
                      </div>
                      <div class="order-facts__rows">
                        <div class="order-facts__row">
                          <span>{{ $t("titles.orderType") }}</span>
                          <strong>
                            {{
                              allData.order_type == "normal"
                                ? $t("ordinary")
                                : $t("sechudle")
                            }}
                          </strong>
                        </div>
                        <div class="order-facts__row" v-if="allData.distance">
                          <span>{{ $t("titles.distance") }}</span>
                          <strong>{{ allData.distance }}</strong>
                        </div>
                        <div class="order-facts__row">
                          <span>{{ $t("titles.payType") }}</span>
                          <strong
                            class="order-facts__pill"
                            :class="allData.is_payment === 'paid' ? 'is-ok' : 'is-wait'"
                          >
                            {{ allData.is_payment_trans }}
                          </strong>
                        </div>
                        <div class="order-facts__row">
                          <span>{{ $t("titles.payWay") }}</span>
                          <strong>{{ allData.pay_type }}</strong>
                        </div>
                        <div class="order-facts__row">
                          <span>{{ $t("titles.date") }}</span>
                          <strong>{{ allData.scheduled_at }}</strong>
                        </div>
                        <div class="order-facts__row">
                          <span>{{ $t("delviery_type") }}</span>
                          <strong
                            class="order-facts__pill"
                            :class="allData.is_pickup_from_branch ? 'is-wait' : 'is-ok'"
                          >
                            {{
                              allData.is_pickup_from_branch
                                ? $t("pickup_from_branch")
                                : $t("delivery_to_home")
                            }}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                <div class="order-history">
                  <div class="order-history__head">
                    <span class="order-history__icon">
                      <v-icon>mdi-timeline-clock-outline</v-icon>
                    </span>
                    <h2 class="title">{{ $t("order_history") }}</h2>
                  </div>
                  <ul>
                    <li
                      v-for="(item, index) in allData.order_status_times"
                      :key="index"
                      :class="{
                        'is-current':
                          index === allData.order_status_times.length - 1,
                      }"
                    >
                      <div
                        v-for="(value, key) in item"
                        :key="key"
                        class="order-history__row"
                      >
                        <div class="order-history__status">
                          {{
                            $te(`ordersStatus.${key}`)
                              ? $t(`ordersStatus.${key}`)
                              : key
                          }}
                        </div>
                        <div class="order-history__time">{{ value }}</div>
                      </div>
                    </li>
                  </ul>
                </div>
                  </div>
                  <div
                    class="col-12 order-map"
                    v-if="allData.address_data && allData.address_data.lat && allData.address_data.lng"
                  >
                    <div class="customer">
                      <GmapMap
                        style="width: 100%; height: 200px"
                        :zoom="10"
                        :center="{
                          lat: +allData.address_data.lat,
                          lng: +allData.address_data.lng,
                        }"
                        ref="map"
                      >
                        <GmapMarker
                          :position="{
                            lat: +allData.address_data.lat,
                            lng: +allData.address_data.lng,
                          }"
                          :draggable="false"
                        />
                      </GmapMap>
                      <a
                        class="address-card__map"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="`https://maps.google.com/?q=${allData.address_data.lat},${allData.address_data.lng}`"
                      >
                        <v-icon small>mdi-map</v-icon>
                        {{ $t("clientLocation") }}
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6 col-xxl-4" v-if="allData.review">
                    <div class="customer">
                      <div class="item">
                        <div class="icon">
                          <v-icon>fa-regular fa-user</v-icon>
                        </div>
                        <div class="info">
                          <h5 class="title">{{ $t("titles.review") }}</h5>
                          <span>
                            {{ allData.review.comment }}
                            <i
                              v-if="allData.review.status == 'like'"
                              class="fas fa-thumbs-up"
                            ></i>
                            <i class="fas fa-thumbs-down" v-else></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12"
                    v-if="allData.files.length || allData.images.length"
                  >
                    <div class="customer">
                      <div class="item">
                        <div class="icon">
                          <v-icon>fa-solid fa-file</v-icon>
                        </div>
                        <div class="info">
                          <h5 class="title">{{ $t("titles.prescription") }}</h5>
                          <div class="showFiles">
                            <div class="files">
                              <div
                                class="file"
                                v-for="(file, index) in allData.images"
                                :key="index"
                              >
                                <img
                                  :src="file.image"
                                  width="300"
                                  height="150"
                                  @click="show_model_1(file.image)"
                                />
                              </div>
                              <div
                                class="file"
                                v-for="(file, index) in allData.files"
                                :key="index"
                              >
                                <iframe
                                  :src="file.image"
                                  width="300"
                                  height="150"
                                ></iframe>
                                <button
                                  class="btn"
                                  @click="show_model(file.image)"
                                >
                                  {{ $t("labels.ope") }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div
                    class="col-md-6 col-xxl-4"
                    v-if="!allData.is_pickup_from_branch"
                  >
                    <div class="customer">
                      <div class="item">
                        <div class="icon">
                          <v-icon>fa-regular fa-user</v-icon>
                        </div>
                        <div class="info">
                          <h5 class="title">{{ $t("titles.driver") }}</h5>
                          <template v-if="!allData.driver">
                            <v-btn
                              v-if="
                                (!allData.is_assign_driver &&
                                  !allData.have_item_out_of_stock &&
                                  allData.status == 'progress') ||
                                (!allData.is_assign_driver &&
                                  allData.have_item_out_of_stock &&
                                  allData.confirm_out_of_stock_status ==
                                    'finished' &&
                                  allData.status == 'progress')
                              "
                              class="px-10"
                              color="#1B5E20"
                              style="color: white"
                              @click="
                                selectDriveModal = true;
                                getDrivers();
                              "
                            >
                              {{ $t("assignDriver") }}
                            </v-btn>
                          </template>
                          <template v-else>
                            <p>
                              {{ $t("titles.name") }}:
                              {{ allData.driver.full_name }}
                            </p>

                            <p>
                              <span>{{ $t("titles.phone") }}</span>
                              <span>
                                {{ allData.driver.phone_complete_form }}
                              </span>
                            </p>
                          </template>
                          <v-btn
                            v-if="
                              allData.is_assign_driver &&
                              allData.status == 'progress'
                            "
                            class="px-10"
                            color="#1B5E20"
                            style="color: white"
                            @click="
                              selectDriveModal = true;
                              getDrivers();
                            "
                          >
                            {{ $t("changeDriver") }}
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <transition name="fadeInUp">
                    <div
                      v-if="model_1.show_model"
                      class="baseModel"
                      @click.stop="model_1.show_model = false"
                    >
                      <div class="main" @click.stop>
                        <span
                          @click.stop="model_1.show_model = false"
                          class="close"
                        >
                          <v-icon>fas fa-times</v-icon>
                        </span>

                        <div class="notificationPopup">
                          <img :src="model_1.model_img_src" alt="img" />
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="model.show_model"
                      class="baseModel"
                      @click.stop="model.show_model = false"
                    >
                      <div class="main" @click.stop>
                        <span
                          @click.stop="model.show_model = false"
                          class="close"
                        >
                          <v-icon>fas fa-times</v-icon>
                        </span>

                        <div class="notificationPopup">
                          <iframe :src="model.model_file_src"></iframe>
                        </div>
                      </div>
                    </div>
                  </transition>
            </div>
          </div>

          <div class="product-details">
            <div class="row">
              <div class="col-lg-8">
                <div class="d-flex justify-content-between">
                  <h2 class="title">{{ $t("titles.products") }}</h2>
                  <div class="px-3 pb-1 frm-action d-flex flex-row gap-2">
                    <button class="export btn">
                      <export-excel
                        :fetch="exportFields"
                        :meta="json_meta"
                        :name="$t(`titles.order_products`)"
                        :worksheet="$t(`titles.order_products`)"
                      >
                        Export <i class="fal fa-download"></i
                      ></export-excel>
                    </button>
                    <button
                      class="export btn"
                      :disabled="outLoading"
                      v-if="selected.length"
                      @click="makeOutOfStock"
                    >
                      {{ $t("makeOutOfStock") }}
                    </button>
                  </div>
                </div>
                <v-data-table
                  class="elevation-1 thumb diff_table"
                  :headers="headers"
                  :items="rows"
                  :search="search"
                  :loading="loading"
                  v-model="selected"
                  :show-select="
                    allData.status == 'order_placed' && !allData.driver
                  "
                  :loading-text="$t('table.loadingData')"
                  item-key="id"
                  :items-per-page="rows.length"
                  hide-default-footer
                >
                  <template v-slot:[`item.index`]="{ index }">{{
                    index + 1
                  }}</template>
                  <template v-slot:[`item.out_of_stock`]="{ item }">
                    <span
                      class="stock-pill"
                      :class="item.out_of_stock ? 'is-out' : 'is-in'"
                    >
                      {{ item.out_of_stock ? $t("out_of_stock") : $t("in_stock") }}
                    </span>
                  </template>
                  <template v-slot:[`item.product_detail`]="{ item }">
                    <div class="product-cell">
                      <img
                        class="product-cell__img"
                        :src="item.product_detail.image"
                        :alt="item.product_detail.name"
                      />
                      <span class="product-cell__name">{{ item.product_detail.name }}</span>
                    </div>
                  </template>
                  <template v-slot:[`item.quantity`]="{ item }">
                    <span class="qty-pill">{{ item.quantity }}</span>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    <span class="money">{{ item.price }}</span>
                  </template>
                  <template v-slot:[`item.total_price`]="{ item }">
                    <span class="money money--total">{{ item.total_price }}</span>
                  </template>
                  <template v-slot:no-data>
                    {{ $t("table.noData") }}
                  </template>
                </v-data-table>
                <div v-if="allData.note">
                  <h2 class="title mt-2">{{ $t("note") }}</h2>
                  <p class="fs-5 ps-5">"{{ allData.note }}"</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="order-summary">
                  <div class="order-summary__head">
                    <span class="order-summary__icon">
                      <v-icon>mdi-receipt</v-icon>
                    </span>
                    <h2 class="title">{{ $t("titles.orderSummary") }}</h2>
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <td class="title">{{ $t("titles.cart") }}</td>
                        <td class="value">{{ rows.length }}</td>
                      </tr>
                      <tr
                        v-if="
                          allData.price_details
                            .total_item_price_before_discount !=
                          allData.price_details.total_item_price_after_discount
                        "
                      >
                        <td class="title">{{ $t("titles.cartBefore") }}</td>
                        <td class="value">
                          {{
                            allData.price_details
                              .total_item_price_before_discount
                          }}
                          {{ allData.price_details.currency }}
                        </td>
                      </tr>
                      <tr>
                        <td class="title">
                          {{ $t("titles.cartTotal") }}
                          {{
                            allData.price_details
                              .total_item_price_before_discount !=
                            allData.price_details
                              .total_item_price_after_discount
                              ? $t("titles.afterDis")
                              : " "
                          }}
                        </td>
                        <td class="value">
                          {{
                            allData.price_details
                              .total_item_price_after_discount
                          }}
                          {{ allData.price_details.currency }}
                        </td>
                      </tr>
                      <tr v-if="allData.price_details.coupon_price">
                        <td class="title">{{ $t("titles.copounDis") }}</td>
                        <td class="value">
                          {{ allData.price_details.coupon_price }}
                          {{ allData.price_details.currency }}
                        </td>
                      </tr>
                      <tr>
                        <td class="title">{{ $t("titles.deliveryPrice") }}</td>
                        <td class="value">
                          {{ allData.price_details.delivery_price }}
                          {{ allData.price_details.currency }}
                        </td>
                      </tr>
                      <tr>
                        <td class="title">{{ $t("titles.vat") }}</td>
                        <td class="value">
                          {{ allData.price_details.vat_price }}
                          {{ allData.price_details.currency }}
                        </td>
                      </tr>
                      <tr v-if="allData.price_details.discount">
                        <td class="title">{{ $t("titles.discount") }}</td>
                        <td class="value">
                          {{ allData.price_details.discount }}
                          {{ allData.price_details.currency }}
                        </td>
                      </tr>
                    </tbody>
                    <div class="line"></div>
                    <tfoot>
                      <tr>
                        <td class="title">{{ $t("titles.total") }}</td>
                        <td class="value">
                          {{ allData.price_details.total_price }}
                          {{ allData.price_details.currency }}
                        </td>
                      </tr>
                      <!-- <tr>
                        <td class="title status">الحالة</td>
                        <td class="value">
                          <span
                            v-if="allData.status == 'finished'"
                            class="status success bg-transparent"
                          >
                            {{ allData.status_trans }}
                          </span>
                          <span
                            v-else-if="allData.status == 'store_reject'"
                            class="status canceled bg-transparent"
                          >
                            {{ allData.status_trans }}
                          </span>
                          <span v-else class="status pending bg-transparent">
                            {{ allData.status_trans }}
                          </span>
                        </td>
                      </tr> -->
                    </tfoot>
                  </table>
                </div>

                <!-- <v-divider></v-divider> -->

              </div>
            </div>
          </div>

        </div>
        <!-- End Statistics Card-->
        <!-- Start:: Text Content Modal -->
        <DeleteModel
          :id="allData.id"
          @toggleModal="toggleDeleteModal"
          :modalIsActive="deleteModalIsOpen"
          :elementIdToGet="deleteItemToShow"
        />
        <!-- End:: Text Content Modal -->
      </div>
    </transition-group>
    <v-dialog class="" v-model="reject_reason_model" width="500" persistent>
      <v-card>
        <v-card-title> {{ $t("messages.orderCancel") }}</v-card-title>
        <v-card-text>
          <div class="input_wrapper">
            <!-- :label="allData.status_trans" -->

            <v-select
              solo
              v-model="reject_reason"
              :items="reject_reasons"
              style="
                border: 1px solid var(--mainColor-2);
                border-radius: 10px;
                padding: 10px !important;
              "
            ></v-select>
          </div>
          <!-- <v-textarea
            v-model="reject_reason"
            class="w-100 p-5"
            :placeholder="$t('forms.labels.rejectReason')"
            style="
              border: 1px solid var(--mainColor-2);
              border-radius: 10px;
              padding: 10px !important;
            "
          >
          </v-textarea> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#F44336" @click="changeStatus()">
            {{ $t("confirm") }}
          </v-btn>
          <v-btn color="#1B5E20" @click="reject_reason_model = false">
            {{ $t("back") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog class="" v-model="selectDriveModal" width="500">
      <v-card>
        <v-card-title> {{ $t("selectDriver") }}</v-card-title>
        <v-card-text>
          <div class="input_wrapper top_label">
            <v-select
              :label="$t('selectDriver')"
              solo
              :items="drivers"
              v-model="selectedDriver"
            ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#F44336"
            :disabled="!selectedDriver"
            @click="assignDrive(allData.is_assign_driver)"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn color="#1B5E20" @click="selectDriveModal = false">
            {{ $t("back") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectShippingWayModal" max-width="460">
      <v-card class="shipping-choice">
        <div class="shipping-choice__head">
          <div>
            <h3>
              {{ shippingAction === "reassign" ? $t("changeShippingCompany") : $t("selectShippingWay") }}
            </h3>
            <p>{{ $t("shippingChoiceHint") }}</p>
          </div>
          <button
            type="button"
            class="shipping-choice__close"
            @click="selectShippingWayModal = false"
          >
            <v-icon small>mdi-close</v-icon>
          </button>
        </div>
        <div class="shipping-options">
          <button
            type="button"
            class="shipping-option"
            :class="{ 'is-selected': shipping_way === 'alshrouq', 'is-disabled': !canUseAlshrouq }"
            :disabled="!canUseAlshrouq"
            @click="canUseAlshrouq && (shipping_way = 'alshrouq')"
          >
            <span class="shipping-option__icon">
              <v-icon>mdi-truck-fast</v-icon>
            </span>
            <span class="shipping-option__copy">
              <span class="shipping-option__name">{{ $t("forms.labels.alshrouq") }}</span>
              <span class="shipping-option__hint">{{ canUseAlshrouq ? $t("forms.labels.alshrouq_hint") : $t("forms.labels.alshrouq_unavailable") }}</span>
            </span>
            <span class="shipping-option__mark"></span>
          </button>
          <button
            type="button"
            class="shipping-option"
            :class="{ 'is-selected': shipping_way === 'company' }"
            @click="shipping_way = 'company'"
          >
            <span class="shipping-option__icon">
              <v-icon>mdi-truck-delivery</v-icon>
            </span>
            <span class="shipping-option__copy">
              <span class="shipping-option__name">{{ $t("forms.labels.company") }}</span>
              <span class="shipping-option__hint">{{ $t("forms.labels.company_hint") }}</span>
            </span>
            <span class="shipping-option__mark"></span>
          </button>
          <button
            type="button"
            class="shipping-option"
            :class="{ 'is-selected': shipping_way === 'branch' }"
            @click="shipping_way = 'branch'"
          >
            <span class="shipping-option__icon">
              <v-icon>mdi-store</v-icon>
            </span>
            <span class="shipping-option__copy">
              <span class="shipping-option__name">{{ $t("forms.labels.from_branch") }}</span>
              <span class="shipping-option__hint">{{ $t("forms.labels.from_branch_hint") }}</span>
            </span>
            <span class="shipping-option__mark"></span>
          </button>
        </div>
        <div class="shipping-choice__foot">
          <button
            type="button"
            class="shipping-choice__back"
            @click="selectShippingWayModal = false"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="shipping-choice__confirm"
            :disabled="!shipping_way || (shipping_way === 'alshrouq' && !canUseAlshrouq)"
            @click="changeStatus($event, 'order_placed')"
          >
            {{ $t("confirm") }}
          </button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import DeleteModel from "@/components/Modals/DeleteModel.vue";
// End:: Importing Modals

export default {
  props: ["id"],
  name: "Withdraw",

  components: {
    DeleteModel,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.orders.title"),
          disabled: true,
          href: "",
        },

        // {
        //   text: this.$t("breadcrumb.transaction.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},
      rows: null,
      selected: [],
      drivers: [],
      reject_reasons: [],

      // ========== Top Section
      search: "",
      outLoading: false,
      selectDriveModal: false,
      selectedDriver: null,
      rejectedReason: "",

      deleteModalIsOpen: false,
      deleteItemToShow: null,

      selectShippingWayModal: false,
      shipping_way: null,
      shippingAction: "accept",

      // ========== Your Data
      allData: null, // injected in created

      // ========== Loading
      loading: false,
      reportReasonToShow: null,
      btnIsLoading: false,
      e1: 1,

      model: {
        show_model: false,
        model_file_src: "",
      },

      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // reject reason
      reject_reason_model: false,
      selectedStatus: null,
      reject_reason: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    canUseAlshrouq() {
      return !!(this.allData && this.allData.branch && this.allData.branch.has_alshrouq);
    },
    addressMapUrl() {
      const address = this.allData && this.allData.address;
      const fallback = this.allData && this.allData.address_data;
      const point = address && address.lat != null ? address : fallback;
      if (!point || point.lat == null || point.lng == null) {
        return "";
      }
      return "https://www.google.com/maps?q=" + point.lat + "," + point.lng;
    },
    clientInitials() {
      const name = this.allData && this.allData.client && this.allData.client.full_name;
      if (!name) {
        return "?";
      }
      return name.trim().charAt(0);
    },
    shippingDriver() {
      const driver = this.allData && this.allData.shipping_driver;
      if (!driver) {
        return null;
      }
      if (!driver.name && !driver.phone && driver.lat == null && driver.lng == null) {
        return null;
      }
      return driver;
    },
    canChangeShipping() {
      if (!this.allData || this.allData.shipping_status !== "cancelled") {
        return false;
      }
      const blocked = [
        "delivered",
        "admin_cancel",
        "admin_reject",
        "client_cancel",
        "driver_cancel",
        "admin_cancel_after_delivered",
      ];
      return blocked.indexOf(this.allData.status) === -1;
    },
    showShippingPanel() {
      return !!(
        this.allData &&
        (this.allData.shipping_status ||
          this.allData.tracking_url ||
          this.shippingDriver ||
          this.canChangeShipping)
      );
    },
    shippingProviderLabel() {
      const provider = this.allData && this.allData.shipping_provider;
      if (provider === "alshrouq") {
        return this.$t("forms.labels.alshrouq");
      }
      if (provider === "roboost") {
        return this.$t("forms.labels.company");
      }
      return "";
    },
    shippingTone() {
      const status = this.allData && this.allData.shipping_status;
      if (status === "cancelled" || status === "driver_can_not_delivered" || status === "Return_to_Origin") {
        return "is-danger";
      }
      if (status === "cancellation_processing" || status === "pending_driver" || status === "order_created") {
        return "is-warn";
      }
      if (status === "delivered") {
        return "is-ok";
      }
      return "is-info";
    },
    driverMapUrl() {
      const driver = this.shippingDriver;
      if (!driver || driver.lat == null || driver.lng == null) {
        return "";
      }
      return "https://www.google.com/maps?q=" + driver.lat + "," + driver.lng;
    },
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "المنتج",
            align: "center",
            value: "product_detail",
            sortable: false,
          },
          {
            text: "كود المنتج",
            align: "center",
            value: "product_detail.code",
            sortable: false,
          },
          {
            text: "حالة المخزون",
            align: "center",
            value: "out_of_stock",
            sortable: false,
          },
          // {
          //   text: "الوصف",
          //   align: "center",
          //   value: "product.desc",
          //   sortable: false,
          // },
          {
            text: "سعر المنتج",
            align: "center",
            value: "price",
            sortable: false,
          },
          {
            text: "الكمية",
            align: "center",
            value: "quantity",
            sortable: false,
          },
          {
            text: "السعر الكلي",
            align: "center",
            value: "total_price",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "Product",
            align: "center",
            value: "product_detail",
            sortable: false,
          },
          {
            text: "Product Code",
            align: "center",
            value: "product_detail.code",
            sortable: false,
          },
          {
            text: "Stock status",
            align: "center",
            value: "out_of_stock",
            sortable: false,
          },
          // {
          //   text: "Has Prescription",
          //   align: "center",
          //   value: "product.desc",
          //   sortable: false,
          // },
          {
            text: "Price",
            align: "center",
            value: "price",
            sortable: false,
          },
          {
            text: "Quantity",
            align: "center",
            value: "quantity",
            sortable: false,
          },
          {
            text: "Total Price",
            align: "center",
            value: "total_price",
            sortable: false,
          },
        ];
      }
    },
  },

  watch: {
    reject_reason_model(newVal) {
      if (newVal == true) {
        this.getReasons();
      } else if (newVal == false) {
        this.selectedStatus = this.allData.status;
      }
    },
  },

  methods: {
    show_model_1(src) {
      this.model_1.model_img_src = src;
      this.model_1.show_model = true;
    },
    show_model(src) {
      this.model.model_file_src = src;
      this.model.show_model = true;
    },
    exportFields() {
      let newData = [];
      this.rows.forEach((el) => {
        let newObject = {};
        // newObject[`${this.$t("forms.labels.image")}`] = el?.media.length
        //   ? el.media[0].image
        //   : this.$t("notFound");
        newObject[`${this.$t("forms.labels.name")}`] = el.product_detail.name;
        newObject[`${this.$t("forms.labels.product_code")}`] =
          el.product_detail.code;
        newObject[`${this.$t("forms.labels.price")}`] = el.price;
        newObject[`${this.$t("forms.labels.quantity")}`] = el.quantity;
        newObject[`${this.$t("forms.labels.total_price")}`] = el.total_price;
        // newObject[`${this.$t("forms.labels.status")}`] = el.is_active
        //   ? this.$t("active")
        //   : this.$t("inactive");
        // newObject[`${this.$t("forms.labels.city")}`] = el.city;
        newData.push(newObject);
      });
      return newData;
    },
    // ===== Toggle Delete Modal =====
    toggleDeleteModal(item) {
      this.deleteItemToShow = item;
      this.deleteModalIsOpen = !this.deleteModalIsOpen;
    },

    // Set Rows
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "order/" + this.id,
      })
        .then((res) => {
          this.allData = res.data.data;

          this.rows = res.data.data.items;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    checkShippingWay(action = "accept") {
      this.shippingAction = action;
      this.shipping_way = null;
      this.selectShippingWayModal = true;
    },

    //Change Status
    changeStatus(event, e) {
      let currStatus;
      if (e) {
        currStatus = e;
      } else {
        currStatus = this.selectedStatus ?? "admin_reject";
      }

      this.btnIsLoading = true;
      let submit_data = new FormData();
      let keepGoing = true;
      if (currStatus == "admin_cancel") {
        if (!this.reject_reason) {
          if (!this.reject_reason_model) {
            this.reject_reason_model = true;

            return;
          }
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.reject_reason"),
            position: "bottomRight",
          });
          keepGoing = false;
        }

        submit_data.append("reject_reason_id", this.reject_reason);
      }
      if (currStatus == "admin_reject") {
        if (!this.reject_reason) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.reject_reason"),
            position: "bottomRight",
          });
          keepGoing = false;
        }

        submit_data.append("reject_reason_id", this.reject_reason);
      }
      if (currStatus == "on_the_way") {
        submit_data.append("driver_id", this.allData.driver?.id);
        // if (!this.selectedDriver) {
        //   this.getDrivers();
        //   keepGoing = false;
        // }
        // else {
        //   keepGoing = true;
        // }
      }
      if (!keepGoing) {
        return;
      }

      submit_data.append("status", currStatus);
      if (this.allData.branch.have_shipping_integration && !this.allData.is_pickup_from_branch ) {
        submit_data.append("shipping_type", this.shipping_way);
      }
      submit_data.append("_method", "PUT");
      const requestUrl =
        this.shippingAction === "reassign" && currStatus === "order_placed"
          ? `order/${this.id}/reassign_shipping`
          : `order/${this.id}/change_status`;
      this.$axios({
        method: "POST",
        url: requestUrl,
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.reject_reason_model = false;
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.btnIsLoading = false;
          this.selectDriveModal = false;
          this.selectedDriver = null;
          this.shipping_way = null;
          this.shippingAction = "accept";
          this.selectShippingWayModal = false;
          this.setRows();
        })
        .catch((err) => {
          this.selectedDriver = null;

          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });

          this.setRows();
          this.btnIsLoading = false;
        });
    },

    assignDrive(driver) {
      const submit_data = new FormData();
      submit_data.append("driver_id", this.selectedDriver);
      submit_data.append("_method", "PUT");
      let url;
      if (driver) {
        url = `order/${this.id}/re_assign_driver_to_client`;
      } else {
        url = `order/${this.id}/assign_driver_to_client`;
      }
      this.$axios({
        method: "POST",
        url: url,
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          this.selectDriveModal = false;
          this.selectedDriver = null;
          this.setRows();
        })
        .catch((err) => {
          this.selectedDriver = null;
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },

    makeOutOfStock() {
      this.outLoading = true;
      let submit_data = new FormData();
      submit_data.append("status", "progress");
      this.selected.map((el, i) =>
        submit_data.append(`out_of_stock_ids[${i}]`, el.id)
      );

      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `order/${this.id}/change_status`,
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.selected = [];
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.outLoading = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.outLoading = false;
        });
    },
    getDrivers() {
      this.$axios
        .get(`order/${this.id}/online_drivers`)
        .then((res) => {
          this.drivers = res.data.data.map((el) => ({
            value: el.id,
            text: el.full_name,
          }));
        })
        .catch(() => (this.selectDriveModal = true));
    },
    getReasons() {
      this.$axios
        .get(`reject_reasons`)
        .then((res) => {
          this.reject_reasons = res.data.data.map((el) => ({
            value: el.id,
            text: el.title,
          }));
        })
        .catch(() => (this.selectDriveModal = true));
    },

    orderStatusList(status) {
      if (this.allData.is_pickup_from_branch) {
        if (status == "pending") {
          return [
            {
              text: this.$t("accept"),
              value: "order_placed",
            },
            { text: this.$t("reject"), value: "admin_reject" },
          ];
        } else if (status == "order_placed") {
          return [
            {
              text: this.$t("progress"),
              value: "progress",
            },
            { text: this.$t("cancel"), value: "admin_cancel" },
          ];
        } else if (status == "progress") {
          return [
            {
              text: this.$t("deliverd"),
              value: "delivered",
            },
            { text: this.$t("cancel"), value: "admin_cancel" },
          ];
        }
      } else {
        if (status == "pending") {
          return [
            {
              text: this.$t("accept"),
              value: "order_placed",
            },
            { text: this.$t("reject"), value: "admin_reject" },
          ];
        } else if (status == "order_placed") {
          return [
            {
              text: this.$t("progress"),
              value: "progress",
            },
            { text: this.$t("cancel"), value: "admin_cancel" },
          ];
        } else if (status == "progress") {
          return [
            {
              text: this.$t("on_the_way"),
              value: "on_the_way",
            },
            { text: this.$t("cancel"), value: "admin_cancel" },
          ];
        } else if (status == "on_the_way") {
          return [
            {
              text: this.$t("arrived"),
              value: "arrived",
            },
            { text: this.$t("cancel"), value: "admin_cancel" },
          ];
        } else if (status == "arrived") {
          return [
            {
              text: this.$t("delivered"),
              value: "delivered",
            },
            { text: this.$t("cancel"), value: "admin_cancel" },
          ];
        }
      }
    },
    orderStatus(status) {
      let message = "";
      switch (status) {
        case "pending":
          message = this.$t("orderStatus.new");
          break;
        case "store_accept ":
          message = this.$t("orderStatus.new");

          break;
        case "in_progress":
          message = this.$t("orderStatus.progress");

          break;
        case "store_reject":
          message = this.$t("orderStatus.reject");

          break;
        case "admin_cancel":
          message = this.$t("orderStatus.cancel");

          break;
        default:
      }
      return message;
    },
    companyStatus(status) {
      let message = "";
      switch (status) {
        case "Return_to_Origin":
          message = this.$t("companyStatus.Return_to_Origin");
          break;
        case "cancelled":
          message = this.$t("companyStatus.cancelled");

          break;
        case "driver_can_not_delivered":
          message = this.$t("companyStatus.driver_can_not_delivered");

          break;
        case "delivered":
          message = this.$t("companyStatus.delivered");

          break;
        case "driver_arrived_to_dropoff_order":
          message = this.$t("companyStatus.driver_arrived_to_dropoff_order");

          break;
        case "driver_on_way_to_client":
          message = this.$t("companyStatus.driver_on_way_to_client");

          break;
        case "driver_picked_order":
          message = this.$t("companyStatus.driver_picked_order");

          break;
        case "driver_arrived_to_pickup":
          message = this.$t("companyStatus.driver_arrived_to_pickup");

          break;
        case "order_assign_to_driver":
          message = this.$t("companyStatus.order_assign_to_driver");

          break;
        case "driver_on_way_to_pickup":
          message = this.$t("companyStatus.driver_on_way_to_pickup");

          break;
        default:
      }
      return message;
    },
  },
  created() {
    this.setRows();
  },

  // ======= hooks
};
</script>

<style lang="scss">
.order-details-page {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 11%);
  padding: 20px 0;
  .baseModel {
    width: 100vw;
    height: 100vh;
    position: fixed;
    inset: 0;
    z-index: 999;
    background: #333333d4;
    display: flex;
    justify-content: center;
    align-items: center;
    .notificationPopup {
      text-align: center;
      img {
        width: 100%;
        max-height: 600px;
        border-radius: 10px;
      }
      iframe {
        width: 100%;
        height: 600px;
        border-radius: 10px;
      }
    }
    .main {
      // width: 800px;

      height: auto;
      background: #fff;
      position: relative;
      border-radius: 10px;
      max-height: 70vh;
      // overflow-y: scroll;
      padding: 22px 30px;
      font-size: 16px;
      min-height: 200px;
      width: 80vw;

      .close {
        position: absolute;
        top: -15px;
        right: -15px; // RTL
        cursor: pointer;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mainColor-2);
        border-radius: 50%;
        z-index: 99;

        i {
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
  .showFiles {
    .files {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      margin-top: 5px;
      // max-width: inherit;
      // overflow-x: scroll;

      .file {
        position: relative;
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        button.btn {
          background: var(--mainColor-2) !important;
          color: #fff !important;
          height: 40px;
          font-size: 16px;
          width: fit-content;
          align-self: center;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }

        iframe {
          width: 150px;
          height: 150px;
          border-radius: 10px;
        }

        img {
          width: 150px;
          height: 150px;
          border-radius: 10px;
        }
      }
    }
  }
  h2.title {
    font-size: 14px !important;
    padding: 0 10px;
    font-weight: bold !important;
    text-align: start !important;
  }
  span.status {
    font-size: 14px;
    &.finished {
      color: #02bc77;
    }
    &.pendding {
      color: #ffc800;
    }
    &.shipping {
      color: #a900ff;
    }
  }
  .status {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 10px;
  }
  .action {
    .v-input {
      padding: 0;
      margin: 0;
    }
    .v-input__control {
      background: #e7e7e7;
      padding: 8px;
      max-width: 200px;
      border-radius: 5px;
    }
    .v-text-field__details {
      display: none !important;
    }
    .v-input__slot {
      margin: 0;
      &::before {
        content: unset !important;
      }
    }
    .v-select__slot {
      &::after {
        content: unset !important;
      }
    }
    input[role="readonly"] {
      display: none !important;
    }
  }
  .details {
    padding: 0 10px;
    h5.title {
      color: #000;
      font-size: 14px !important;
      font-weight: bold;
      margin-bottom: 0%;
    }
    .item {
      display: flex;
      align-items: flex-start;
      .icon {
        background: #f5f5fa;
        border-radius: 50%;
        width: 50px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px !important;
        * {
          color: #000;
        }
      }
      .info {
        flex: 1;
        margin-inline-start: 8px;
        background: none !important;
        p {
          font-size: 14px;
          color: #8d8d8d;
          margin-bottom: 0;
          &:not(:last-child) {
            margin-bottom: 4px;
          }
        }
      }
    }
  }
  .product-details {
    padding: 0 10px;
    h2.title {
      font-size: 18px !important;
    }
  }
  table {
    width: 100%;
    td.title {
      font-size: 16px !important;
      line-height: 1.7;
      &.status {
        font-size: 14px !important;
        padding: 0;
      }
    }
    td.value {
      font-size: 14px !important;
      font-weight: bold;
      text-align: end;

      span.status {
        justify-content: flex-end;
        padding: 0;
      }
    }
  }

  div.line {
    padding: 10px 0;
  }
  tfoot {
    border-top-width: 1px;
    margin-top: 10px;
  }
}

.btns_actions {
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    margin: 5px;
  }
}

.shipping-panel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  margin: 14px 10px 0;
  padding: 12px 14px;
  background: #f7f8f6;
  border: 1px solid #e6e8e3;
  border-radius: 12px;
}

.shipping-panel__main,
.shipping-panel__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
}

.shipping-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;

  .v-icon {
    color: inherit;
    font-size: 16px;
  }

  &.is-ok {
    background: #e8f6ee;
    color: #1b5e20;
  }

  &.is-danger {
    background: #fdecea;
    color: #c62828;
  }

  &.is-warn {
    background: #fff6e0;
    color: #8a6a00;
  }

  &.is-info {
    background: #eef2ff;
    color: #3949ab;
  }
}

.shipping-provider {
  font-size: 13px;
  color: #5f6368;
}

.shipping-driver {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #202124;

  .v-icon {
    color: #1b5e20;
  }

  strong,
  a {
    display: block;
    line-height: 1.3;
  }

  a {
    color: #1b5e20;
    text-decoration: none;
  }
}

.shipping-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #1b5e20;
  text-decoration: none;

  .v-icon {
    color: inherit;
  }
}

.shipping-change {
  margin-inline-start: auto;
}

.v-dialog__content .v-dialog .shipping-choice.v-card {
  padding: 0 !important;
  border-radius: 16px;
  overflow: hidden;
}

.shipping-choice__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 18px 8px;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #1b5e20;
    line-height: 1.3;
  }

  p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #6b7280;
  }
}

.shipping-choice__close {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: #f3f4f6;
  color: #374151;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .v-icon {
    color: inherit;
  }
}

.shipping-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 18px 4px;
}

.shipping-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: start;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  color: #111827;

  &:hover {
    border-color: #9ccc9c;
    background: #fbfefb;
  }

  &.is-disabled {
    cursor: not-allowed;
    opacity: 0.55;
    background: #f9fafb;

    &:hover {
      border-color: #e5e7eb;
      background: #f9fafb;
    }
  }

  &.is-selected {
    border-color: #1b5e20;
    background: #f3faf4;
    box-shadow: inset 0 0 0 1px #1b5e20;

    .shipping-option__icon {
      background: #1b5e20;
      color: #fff;
    }

    .shipping-option__mark {
      border-color: #1b5e20;
      background: #1b5e20;

      &::after {
        opacity: 1;
      }
    }
  }
}

.shipping-option__icon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eef6ef;
  color: #1b5e20;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .v-icon {
    color: inherit;
    font-size: 20px;
  }
}

.shipping-option__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.shipping-option__name {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
}

.shipping-option__hint {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.4;
}

.shipping-option__mark {
  flex: 0 0 auto;
  margin-inline-start: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    inset: 4px;
    border-radius: 50%;
    background: #fff;
    opacity: 0;
  }
}

.shipping-choice__foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 18px 18px;
}

.shipping-choice__back,
.shipping-choice__confirm {
  min-width: 112px;
  height: 42px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.shipping-choice__back {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
}

.shipping-choice__confirm {
  border: 0;
  background: #1b5e20;
  color: #fff;

  &:disabled {
    background: #c5d4c6;
    color: #fff;
    cursor: not-allowed;
  }
}

.order-details-page {
  background: #f3f5f0;
  border: 0;
  box-shadow: none;
  padding: 0 0 8px;

  .order-status {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 18px;
    margin: 0 0 14px;
    padding: 18px 20px;
    background: #fff;
    border: 1px solid #e4eadf;
    border-inline-start: 5px solid #1b5e20;
    border-radius: 18px;
    box-shadow: 0 8px 20px rgba(20, 33, 22, 0.04);
  }

  .order-status > h2.title {
    flex: 1 1 220px;
    margin: 0;
    padding: 0;
    font-size: 26px !important;
    line-height: 1.2;
    color: #142116;
  }

  .order-status > .status {
    flex: 1 1 280px;
    align-items: center;
    gap: 12px;
    padding: 0;
    margin: 0;
  }

  span.status.bg-transparent {
    border-radius: 999px;
    font-size: 13px;
    font-weight: 700;
    padding: 5px 12px !important;
  }

  span.status.success.bg-transparent {
    background: #e7f6ee !important;
    color: #1b5e20 !important;
  }

  span.status.canceled.bg-transparent {
    background: #fdecea !important;
    color: #c62828 !important;
  }

  span.status.pending.bg-transparent {
    background: #fff6e0 !important;
    color: #8a6a00 !important;
  }

  .action .d-flex {
    gap: 8px;
  }

  .action .v-btn {
    border-radius: 10px;
    letter-spacing: 0;
    text-transform: none;
    min-height: 40px;
    box-shadow: none;
    font-weight: 700;
  }

  .action .v-input__control {
    background: #f7f8f6;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
  }

  hr.line {
    display: none;
  }

  .shipping-panel {
    flex: 1 1 100%;
    margin: 6px 0 0;
    padding: 12px 0 0;
    background: transparent;
    border: 0;
    border-top: 1px solid #eef1ea;
    border-radius: 0;
  }

  .details {
    padding: 16px 0 0;

    > .row > [class*="col-"] {
      margin-bottom: 12px;
    }

    .customer,
    .order-info,
    .order-history {
      height: 100%;
      background: #fff;
      border: 1px solid #e4eadf;
      border-radius: 16px;
      padding: 16px;
      box-shadow: 0 6px 16px rgba(20, 33, 22, 0.04);
    }

    .order-history {
      .order-history__head {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .order-history__icon {
        width: 48px;
        height: 48px;
        border-radius: 14px;
        background: #e7f6ee;
        color: #1b5e20;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;

        .v-icon {
          color: inherit;
        }
      }

      h2.title {
        margin: 0;
        font-size: 16px !important;
        font-weight: 800;
        color: #142116;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin: 14px 0 0;
        padding: 0;
      }

      ul li {
        list-style: none !important;
        margin: 0 !important;
        padding: 10px 12px;
        background: #f7fbf7;
        border-radius: 10px;

        &.is-current {
          background: #e7f6ee;
        }
      }

      .order-history__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }

      .order-history__status {
        color: #142116;
        font-weight: 700;
        font-size: 13px;
      }

      .order-history__time {
        color: #6b7280;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
      }
    }

    .item .icon {
      width: 44px !important;
      height: 44px !important;
      background: #e7f6ee;
      border: 0;

      .v-icon {
        color: #1b5e20;
        font-size: 16px;
      }
    }

    h5.title {
      margin-bottom: 8px;
      color: #142116;
    }

    .user-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 14px;
    }

    .user-card__top {
      display: flex;
      align-items: center;
      gap: 14px;
    }

    .user-card__avatar {
      width: 64px;
      height: 64px;
      border-radius: 18px;
      object-fit: cover;
      background: #1b5e20;
      color: #fff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      font-weight: 800;
      flex: 0 0 auto;
    }

    .user-card__label {
      display: block;
      font-size: 12px;
      font-weight: 600;
      color: #6b7280;
    }

    .user-card__id strong {
      display: block;
      margin-top: 2px;
      font-size: 18px;
      line-height: 1.3;
      color: #142116;
    }

    .user-card__state {
      display: inline-flex;
      margin-top: 6px;
      border-radius: 999px;
      padding: 3px 10px;
      font-size: 12px;
      font-weight: 700;

      &.is-on {
        background: #e7f6ee;
        color: #1b5e20;
      }

      &.is-off {
        background: #fdecea;
        color: #c62828;
      }
    }

    .user-card__row {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      border-radius: 12px;
      background: #f7fbf7;
      color: #142116;
      text-decoration: none;
      font-weight: 700;

      small {
        display: block;
        font-size: 11px;
        font-weight: 600;
        color: #6b7280;
      }

      .v-icon {
        color: #1b5e20;
      }
    }

    .address-card {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .address-card__top {
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }

    .address-card__pin {
      width: 48px;
      height: 48px;
      border-radius: 14px;
      background: #e7f6ee;
      color: #1b5e20;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;

      .v-icon {
        color: inherit;
      }
    }

    .address-card__label {
      display: block;
      font-size: 12px;
      font-weight: 600;
      color: #6b7280;
    }

    .address-card__id strong {
      display: block;
      margin-top: 2px;
      font-size: 18px;
      line-height: 1.35;
      color: #142116;
    }

    .address-card__country {
      display: inline-flex;
      margin-top: 6px;
      border-radius: 999px;
      padding: 3px 10px;
      background: #f3f5f0;
      color: #374151;
      font-size: 12px;
      font-weight: 700;
    }

    .address-card__desc {
      margin: 0;
      color: #4b5563;
      font-size: 14px;
      line-height: 1.5;
    }

    .address-card__chips {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      span {
        border-radius: 999px;
        padding: 4px 10px;
        background: #f7fbf7;
        border: 1px solid #e4eadf;
        color: #1b5e20;
        font-size: 12px;
        font-weight: 700;
      }
    }

    .address-card__map {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      align-self: flex-start;
      color: #1b5e20;
      font-size: 13px;
      font-weight: 700;
      text-decoration: none;

      .v-icon {
        color: inherit;
      }
    }

    .order-facts {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .order-facts__head {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .order-facts__icon {
      width: 48px;
      height: 48px;
      border-radius: 14px;
      background: #e7f6ee;
      color: #1b5e20;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;

      .v-icon {
        color: inherit;
      }
    }

    .order-facts__title {
      font-size: 16px;
      font-weight: 800;
      color: #142116;
    }

    .order-facts__rows {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .order-facts__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 8px 10px;
      border-radius: 10px;
      background: #f7fbf7;

      > span {
        color: #6b7280;
        font-size: 12px;
        font-weight: 600;
      }

      > strong {
        color: #142116;
        font-size: 13px;
        font-weight: 700;
        text-align: end;
      }
    }

    .order-facts__pill {
      border-radius: 999px;
      padding: 3px 10px;

      &.is-ok {
        background: #e7f6ee;
        color: #1b5e20;
      }

      &.is-wait {
        background: #fff6e0;
        color: #8a6a00;
      }
    }

    .info p {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      font-size: 13px;
      line-height: 1.45;
      color: #4b5563;

      span:last-child {
        min-width: 0;
        color: #142116;
        font-weight: 600;
        text-align: end;
        overflow-wrap: anywhere;
      }
    }
  }

  .details .order-map .vue-map-container {
    border-radius: 14px;
    overflow: hidden;
    border: 1px solid #e8ece4;
  }

  .product-details {
    padding: 4px 0 0;

    > .row > .col-lg-8 {
      background: #fff;
      border: 1px solid #e4eadf;
      border-radius: 16px;
      padding: 16px;
      box-shadow: 0 6px 16px rgba(20, 33, 22, 0.04);
    }

    h2.title {
      font-size: 18px !important;
      padding: 0;
      color: #142116;
    }

    .fs-5 {
      margin: 12px 0 0;
      padding: 12px 14px;
      background: #f7fbf7;
      border-inline-start: 4px solid #1b5e20;
      border-radius: 12px;
      color: #142116;
    }

    .export.btn {
      background: #e7f6ee;
      border: 0;
      color: #1b5e20;
      border-radius: 10px;
      height: 36px;
      padding: 0 12px;
      font-weight: 700;
    }

    .v-data-table.diff_table {
      margin-top: 12px;
      margin-bottom: 0;
      border: 1px solid #e4eadf;
      border-radius: 14px !important;
      box-shadow: none !important;
      overflow: hidden;
      background: #fff;

      table {
        border-collapse: collapse !important;
        border-spacing: 0 !important;
      }

      .v-data-table-header {
        background: #f7f8f6 !important;
        border-radius: 0 !important;
      }

      .v-data-table-header tr th {
        background: #f7f8f6 !important;
        color: #4b5563 !important;
        font-size: 12px !important;
        font-weight: 700 !important;
        height: 46px !important;
        border-bottom: 1px solid #e4eadf !important;
      }

      .v-data-table-header__icon {
        color: #6b7280 !important;
      }

      tbody tr {
        transform: none !important;
        box-shadow: none !important;
        background: #fff;
      }

      tbody td {
        height: 72px;
        border-bottom: 1px solid #f0f2ee !important;
        font-size: 14px;
        font-weight: 600;
        color: #142116 !important;
      }

      tbody tr:last-child td {
        border-bottom: 0 !important;
      }

      tbody tr:hover {
        transform: none !important;
        background: #f7fbf7 !important;

        td {
          color: #142116 !important;
        }
      }
    }

    .product-cell {
      display: flex;
      align-items: center;
      gap: 12px;
      text-align: start;
    }

    .product-cell__img {
      width: 48px;
      height: 48px;
      border-radius: 10px;
      object-fit: cover;
      background: #f3f5f0;
      border: 1px solid #e4eadf;
      flex: 0 0 auto;
    }

    .product-cell__name {
      font-weight: 700;
      color: #142116;
      line-height: 1.35;
    }

    .stock-pill,
    .qty-pill {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 28px;
      border-radius: 999px;
      padding: 4px 10px;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.2;
    }

    .stock-pill.is-in {
      background: #e7f6ee;
      color: #1b5e20;
    }

    .stock-pill.is-out {
      background: #fdecea;
      color: #c62828;
    }

    .qty-pill {
      background: #f3f5f0;
      color: #142116;
    }

    .money {
      font-variant-numeric: tabular-nums;
      font-weight: 600;
      color: #374151;
    }

    .money--total {
      color: #1b5e20;
      font-weight: 800;
    }
  }

  .order-summary {
    background: #fff;
    border: 1px solid #e4eadf;
    border-radius: 16px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 6px 16px rgba(20, 33, 22, 0.04);

    .order-summary__head {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 8px;
    }

    .order-summary__icon {
      width: 48px;
      height: 48px;
      border-radius: 14px;
      background: #e7f6ee;
      color: #1b5e20;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;

      .v-icon {
        color: inherit;
      }
    }

    h2.title {
      margin: 0;
      padding: 0;
      font-size: 16px !important;
      font-weight: 800;
      color: #142116;
    }

    .line {
      display: none;
    }

    table {
      border-collapse: separate;
      border-spacing: 0 8px;
    }

    td.title,
    td.value {
      background: #f7fbf7;
      padding: 10px 12px !important;
      font-size: 13px !important;
    }

    td.title {
      color: #6b7280;
      font-weight: 600;
      border-start-start-radius: 10px;
      border-end-start-radius: 10px;
    }

    td.value {
      color: #142116;
      font-weight: 700;
      border-start-end-radius: 10px;
      border-end-end-radius: 10px;
    }

    tfoot td {
      background: #e7f6ee;
      color: #1b5e20 !important;
      padding: 14px 12px !important;
      font-size: 16px !important;
      font-weight: 800;
      border-top: 0;
    }
  }
}
</style>
